import React, { useEffect, useState } from "react"
import _ from "lodash"

const LinkToTop: React.FC<unknown> = () => {
  const [isVisible, setIsVisible] = useState(false)

  // Show button when page is scorlled upto given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  const throttledToggleVisibility = _.throttle(toggleVisibility, 200)

  useEffect(() => {
    window.addEventListener("scroll", throttledToggleVisibility)
    return () => {
      window.removeEventListener("scroll", throttledToggleVisibility)
    }
  }, [])

  return (
    <React.Fragment>
      <div
        className={`c-link-to-top ${isVisible ? "" : "-hidden"}`}
        onClick={scrollToTop}
      ></div>
    </React.Fragment>
  )
}

export default LinkToTop
